<div class="np-panel">

  <!-- Header -->
  <div class="np-header">
    <span class="np-title">Notifications</span>
    <button mat-icon-button class="np-close-btn" (click)="closePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Items -->
  <div class="np-body" *ngIf="notifications.length > 0; else noNotifications">
    <div class="np-item" *ngFor="let notification of notifications">
      <div class="np-icon-wrap" [ngClass]="getIconClass(notification.type)">
        <mat-icon>{{ getIcon(notification.type) }}</mat-icon>
      </div>
      <div class="np-content">
        <p class="np-message">{{ notification.message }}</p>
        <span class="np-time">{{ notification.timestamp | date:'shortTime' }}</span>
      </div>
    </div>
  </div>

  <ng-template #noNotifications>
    <div class="np-empty">
      <mat-icon>notifications_none</mat-icon>
      <span>No new notifications</span>
    </div>
  </ng-template>

</div>